import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/detail/page'));
const BuybackPage = lazy(() => import('../pages/services/buyback/page'));
const EstateClearingPage = lazy(() => import('../pages/services/estate-clearing/page'));
const HouseCleaningPage = lazy(() => import('../pages/services/house-cleaning/page'));
const FullClearingPage = lazy(() => import('../pages/services/full-clearing/page'));
const HoardingCleanupPage = lazy(() => import('../pages/services/hoarding-cleanup/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const AreaPage = lazy(() => import('../pages/area/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/detail',
    element: <ServiceDetailPage />,
  },
  {
    path: '/services/buyback',
    element: <BuybackPage />,
  },
  {
    path: '/services/estate-clearing',
    element: <EstateClearingPage />,
  },
  {
    path: '/services/house-cleaning',
    element: <HouseCleaningPage />,
  },
  {
    path: '/services/full-clearing',
    element: <FullClearingPage />,
  },
  {
    path: '/services/hoarding-cleanup',
    element: <HoardingCleanupPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/area',
    element: <AreaPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;